// 用户中心-发票功能操作
const UserInvoiceRouterMap = [
  // 用户发票详细
  {
    path: '/user/invoice',
    component: Invoice => (require(['@/views/user/invoice'], Invoice))
  },
  // 用户发票列表
  {
    path: '/user/invoice-list',
    component: InvoiceList => (require(['@/views/user/invoiceList'], InvoiceList))
  }
]

export default UserInvoiceRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/invoice.js